import { Component, OnInit }      from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location }               from '@angular/common';

import { GuideService }           from '../guide.service';
import { GuideDetail }            from './../../../models/guide/guide-detail';

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.less'],
  providers: [ GuideService ]
})

export class GuideComponent implements OnInit {
  guide: GuideDetail;

  constructor(
    private guideService: GuideService,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.route.params.forEach((params: Params) => {
      let id = +params['id'];
      this.guideService
          .getGuide(id)
          .subscribe(guide => this.guide = guide);
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/guides/guide/guide.component.ts